import Animation from './Animation';
import './Burn.css';

export default class Burn extends Animation {

	constructor (master, card) {

		super(master, 800);
		this.card = card;
	}

	run () {

		var el = document.getElementById("sensuba-card-" + this.card);
		if (el) {
			el.classList.add("sensuba-card-burn");
			setTimeout(() => el.classList.remove("sensuba-card-burn"), 800);
		}
	}
}


// WEBPACK FOOTER //
// ./src/game/view/animation/Burn.js